import React, { useState, useEffect, useRef } from "react";
import "../css/BackgroundSlideshow.css";

const BackgroundSlideshow = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [preloadingComplete, setPreloadingComplete] = useState(false);
  const loadedCountRef = useRef(0);

  // Preload all images when the images array changes
  useEffect(() => {
    if (!images || images.length === 0) {
      setPreloadingComplete(false);
      return;
    }

    setPreloadingComplete(false);
    loadedCountRef.current = 0;
    const totalImages = images.length;

    const handleImageLoad = () => {
      loadedCountRef.current += 1;
      if (loadedCountRef.current === totalImages) {
        setPreloadingComplete(true);
      }
    };

    images.forEach((src) => {
      const img = new Image();
      img.onload = handleImageLoad;
      img.onerror = handleImageLoad;
      img.src = src;
    });

    // Cleanup on unmount or when images change
    return () => {
      loadedCountRef.current = 0;
    };
  }, [images]);

  // Scorrimento automatico ogni 5 secondi (only after preloading)
  useEffect(() => {
    if (!preloadingComplete || images.length === 0) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [images.length, preloadingComplete]);

  // Don't render until preloading is complete
  if (!preloadingComplete) {
    return null;
  }

  return (
    <div className="background-slideshow">
      {images.map((image, index) => (
        <div
          key={index}
          className={`background-slide ${
            index === currentIndex ? "active" : ""
          }`}
          style={{ backgroundImage: `url(${image})` }}
        />
      ))}
    </div>
  );
};

export default BackgroundSlideshow;
